import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { expensesAPI } from '../api';

const useExpenseStore = create(
  devtools(
    (set) => ({
      // State
      expenses: [],
      loading: false,
      error: null,

      // Fetch expenses with optional params
      fetchExpenses: async (params = {}) => {
        try {
          set({ loading: true, error: null });
          const response = await expensesAPI.list(params);
          set({ expenses: response.data, loading: false });
          return response.data;
        } catch (error) {
          console.error('Error fetching expenses:', error);
          set({
            error: error.response?.data?.detail || 'Failed to fetch expenses',
            loading: false,
          });
          throw error;
        }
      },

      // Create expense
      createExpense: async (data) => {
        try {
          set({ loading: true, error: null });
          const response = await expensesAPI.create(data);
          set((state) => ({
            expenses: [response.data, ...state.expenses],
            loading: false,
          }));
          return response.data;
        } catch (error) {
          console.error('Error creating expense:', error);
          set({
            error: error.response?.data?.detail || 'Failed to create expense',
            loading: false,
          });
          throw error;
        }
      },

      // Update expense
      updateExpense: async (id, data) => {
        try {
          set({ loading: true, error: null });
          const response = await expensesAPI.update(id, data);
          set((state) => ({
            expenses: state.expenses.map((e) =>
              e.ID === id ? response.data : e
            ),
            loading: false,
          }));
          return response.data;
        } catch (error) {
          console.error('Error updating expense:', error);
          set({
            error: error.response?.data?.detail || 'Failed to update expense',
            loading: false,
          });
          throw error;
        }
      },

      // Delete expense
      deleteExpense: async (id) => {
        try {
          set({ loading: true, error: null });
          await expensesAPI.remove(id);
          set((state) => ({
            expenses: state.expenses.filter((e) => e.ID !== id),
            loading: false,
          }));
        } catch (error) {
          console.error('Error deleting expense:', error);
          set({
            error: error.response?.data?.detail || 'Failed to delete expense',
            loading: false,
          });
          throw error;
        }
      },

      // Clear error
      clearError: () => set({ error: null }, false, 'clearError'),
    }),
    {
      name: 'expense-store',
    }
  )
);

export { useExpenseStore };
